import { useSyncExternalStore } from "react";

/**
 * Kişi bu sekmeye BAKIYOR mu: sekme görünür VE pencere odakta.
 *
 * NEDEN İKİSİ BİRDEN. Okundu imleci bir mesajın ÇİZİLDİĞİNE değil, okunduğuna dair bir iddia.
 * Eskiden çizildiği an oynuyordu: arkada açık kalmış bir sekme ya da başka bir pencerenin
 * arkasında kalan tarayıcı, gelen her mesajı okunmuş sayıyordu. Sunucu çevrimiçi alıcıya
 * bildirim üretmediği için mesaj hiçbir yerde iz bırakmadan kayboluyordu (denetim Sohbet 3).
 *
 * - `visibilityState === "visible"` yalnız sekmenin ÖNDE olduğunu söylüyor; yan yana iki
 *   pencerede ikisi de görünürdür.
 * - `document.hasFocus()` klavyenin bu belgede olduğunu söylüyor; tek başına yetmiyor, çünkü
 *   küçültülmüş bir pencere odağını bir süre taşıyabiliyor.
 *
 * Değişimi üç olay haber veriyor: `visibilitychange` (sekme öne/arkaya), `focus` ve `blur`
 * (pencere). İmleç etkisi bu değere bağlı olduğu için, koşul sonradan sağlandığında yeniden
 * deneme ayrıca yazılmıyor — değer değişince etki kendiliğinden yeniden koşuyor.
 *
 * Sunucuda çizim yok: `getServerSnapshot` `false` — görmeyen bir yüzey okumuş sayılmaz.
 *
 * SINIRI: «en altta mı» sorusu burada yok. Kitin `ChatPanel`'i en alta kaydırılmış olup
 * olmadığını dışarı vermiyor (`onAtBottomChange` kit isteği, denetim Sohbet 16).
 */
function subscribe(onChange: () => void): () => void {
  document.addEventListener("visibilitychange", onChange);
  window.addEventListener("focus", onChange);
  window.addEventListener("blur", onChange);
  return () => {
    document.removeEventListener("visibilitychange", onChange);
    window.removeEventListener("focus", onChange);
    window.removeEventListener("blur", onChange);
  };
}

function snapshot(): boolean {
  return document.visibilityState === "visible" && document.hasFocus();
}

export function usePageAttention(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
